module.exports = __webpack_public_path__ + "static/media/Quiz_Card_KO.9270591f.jpg";